import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { withSetPropAction } from "mobx-stores/_extension/with-set-props";
import { Base, IBaseProperties } from "../base";
import { Product } from "../products/product";
export const QuotationItem = types
  .compose(
    Base,
    types.model({
      productId: types.maybeNull(types.string),
      product: types.maybeNull(Product),
      amount: types.maybeNull(types.number),
      unitPrice: types.maybeNull(types.number),
      oldUnitPriceFirst: types.maybeNull(types.number),
      oldUnitPriceDateFirst: types.maybeNull(types.string),
      oldUnitPriceSecond: types.maybeNull(types.number),
      oldUnitPriceDateSecond: types.maybeNull(types.string),
      note: types.maybeNull(types.string),
    })
  )
  .actions(withSetPropAction);
export interface IQuotationItem extends Instance<typeof QuotationItem> {}
export interface IQuotationItemProperties
  extends SnapshotIn<typeof QuotationItem> {}

export interface IAddQuotationItem
  extends Omit<IQuotationItemProperties, "product" | keyof IBaseProperties> {}
export interface IUpdateQuotationItem
  extends Omit<IQuotationItemProperties, "product"> {}
